import { ExportId } from '../types'
import { parseExportYyyymm } from './exportMonth'

export function toExportFilenameMonth(yyyymm?: string): string {
  if (!yyyymm || yyyymm.length !== 6) {
    return ''
  }

  const monthParams = parseExportYyyymm(yyyymm)

  if (!monthParams) {
    return ''
  }

  return `${monthParams.year}-${String(monthParams.month).padStart(2, '0')}`
}

export function getExportFilename(exportId: ExportId, yyyymm?: string): string {
  const monthSuffix = toExportFilenameMonth(yyyymm)

  const filenameMap: Record<ExportId, string> = {
    [ExportId.ACTIVE_PRESCRIBERS]: 'prescribers.csv',
    [ExportId.ACTIVE_ADMINS]: 'organization-admins.csv',
    [ExportId.PRESCRIPTIONS_BY_PRESCRIBER]: `prescriber-prescription-counts-${monthSuffix}.csv`,
    [ExportId.PRESCRIPTIONS]: `prescriptions-${monthSuffix}.csv`,
    [ExportId.PRESCRIBED_ITEMS]: `prescribed-items-full-${monthSuffix}.csv`,
    [ExportId.LITE_PRESCRIBED_ITEMS]: `prescribed-items-lite-${monthSuffix}.csv`,
  }

  return filenameMap[exportId]
}

export function downloadCsv(filename: string, content: string | Blob): void {
  const blob =
    typeof content === 'string' ? new Blob([content], { type: 'text/csv;charset=utf-8;' }) : content
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  URL.revokeObjectURL(url)
}
